import Link                                                      from "next/link";
import { Crown }                                                 from "lucide-react";
import { cor_segura, com_alfa, link_da_categoria }               from "@/utils/RpgFunction";

// Coroas pequenas ao lado do nome: uma por Rei que o jogador segura agora.
export function ReisCoroas({ reis }) {
  if (!Array.isArray(reis) || !reis.length) return null;

  return (
    <span className="inline-flex items-center gap-0.5 flex-shrink-0">
      {reis.filter(Boolean).map((rei, idx) => (
        <Crown
          key={rei.chave || idx}
          className="w-4 h-4"
          style={{ color: cor_segura(rei.cor) }}
          aria-label={rei.nome}
        >
          <title>{rei.nome}</title>
        </Crown>
      ))}
    </span>
  );
}

// Selos com o nome de cada Rei, levando ao ranking da categoria.
export function ReisChips({ reis }) {
  if (!Array.isArray(reis) || !reis.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {reis.filter(Boolean).map((rei, idx) => {
        const cor = cor_segura(rei.cor);
        return (
          <Link
            key={rei.chave || idx}
            href={link_da_categoria(rei.chave)}
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-sm font-rajdhani font-semibold transition-colors hover:brightness-125"
            style={{ color: cor, borderColor: com_alfa(cor, 0.6), backgroundColor: com_alfa(cor, 0.12) }}
          >
            <Crown className="w-4 h-4" />
            {rei.nome}
          </Link>
        );
      })}
    </div>
  );
}
